import axios from 'axios';
import qs from 'qs';
import { Loading } from 'element-ui'
import { getCookie } from '../utils/utils';
import store from '@/store'

//创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 50000 //超时时间
})
let loadinginstace;
let doWithoutLoading = [
  '?r=exam/tmp-question/answer',
  '?r=exam/tmp-question/stat',
  '?r=exam/tmp-question/add-question',
  '?r=course-log/log',
  '?r=exam/exam/step-submit',
  '?r=user/info',
  '?r=series-paper/class-exam-submit',
  '?r=login/qrcode-check',
]
//添加request拦截器
service.interceptors.request.use(config => {
  let isInclude = doWithoutLoading.some((item) => {
    return config.url.indexOf(item) !== -1
  })
  if(!isInclude) {
    loadinginstace = Loading.service({ fullscreen: true });
  }
  return config;
}, error => {
  loadinginstace && loadinginstace.close();
  Promise.reject(error);
})

//添加response拦截器
service.interceptors.response.use(
    response => {
        loadinginstace && loadinginstace.close();
        let res = {};
        res.status = response.status;
        res.data = response.data;
        switch(response.data.code) {
          case 3001:
            store.dispatch('user/openLogin', true);
            store.dispatch('user/clearUserInfo');
            break;
        }
        return res;
    },
    error => {
      console.log(error.response)
      loadinginstace && loadinginstace.close()
        if (error.response && error.response.status == 404) {
            //跳转到xx页面
            console.log("404错误")
        }
        return Promise.reject(error.response)
    }
)

//封装get接口
// params={} 是设置默认值
export function get(url, params = {}) {
    params.t = new Date().getTime(); //get方法加一个时间参数,解决ie下可能缓存问题.
    return service({
        url: url,
        method: 'get',
        headers: {
        },
        params
    })
}

//封装post请求
export function post(url, data = {}) {
    //默认配置
    let sendObject = {
        url: url,
        method: "post",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };
    sendObject.data = qs.stringify(data);
    return service(sendObject)
}

//封装put方法 (resfulAPI常用)
function put(url, data = {}) {
    return service({
        url: url,
        method: 'put',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        },
        data: JSON.stringify(data)
    })
}

//删除方法(resfulAPI常用)
function deletes(url) {
    return service({
        url: url,
        method: 'delete',
        headers: {}
    })
}

//patch方法(resfulAPI常用)
function patch(url) {
    return service({
        url: url,
        method: 'patch',
        headers: {}
    })
}

//处理格式化URL（/demo/{id}）
function render(url, data) {
    var re = /{([^]+)?}/
    var match = '';
    while ((match = re.exec(url))) {
        url = url.replace(match[0], data[match[1]])
    }
    return url
}

const fetch = (options) => {
    //process.env.BASE_API为环境变量在.env文件中配置
    // let url = process.env.BASE_API + options.url;
    // url = render(url, options.data)
    let url = getUrl(options.url)
    switch (options.method.toUpperCase()) {
        case 'GET':
            return get(url, options.data)
        case 'POST':
            return post(url, options.data)
        case 'PUT':
            return put(url, options.data)
        case 'DELETE':
            return deletes(url, options.data)
        case 'PATCH':
            return patch(url, options.data)
        default:
            return service(options)
    }
}

/**
 * 提供一个http方法
 * url 访问路径 不包括域名和项目名
 * data 参数对象
 * method 请求方式
 *  */
export function http(url = '', data = {}, method = "GET") {
    const userId = getCookie('uid');
    const sessionkey = getCookie('sessionkey');
    if (!url.includes('login') && userId) {
        data.userId = userId;
        data.sessionKey = sessionkey;
    }

    const options = { url: url, data: data, method: method }
    
    return fetch(options).catch(error => {
        throw error
    })
}

/**
 * 构造url的方法
 */
export function getUrl(url = '') {
  const URL = process.env.BASE_API + '/camp-' + process.env.ENV_CONFIG + '/pcend/web/index.php' + url;
//   const URL = 'http://smallprogram.sunlands.com/camp-prod/pcend/web/index.php/camp-prod/pcend/web/index.php' + url;
  return URL
}



// WEBPACK FOOTER //
// ./src/utils/http.js